import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { FlexLayoutModule } from "@angular/flex-layout";

import { MatPaginatorModule } from "@angular/material/paginator";
import { MatTableModule } from "@angular/material/table";
import { MatSortModule } from "@angular/material/sort";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatInputModule } from "@angular/material/input";
import { MatTabsModule } from "@angular/material/tabs";
import { MatSelectModule } from "@angular/material/select";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatCardModule } from "@angular/material/card";
import { MatListModule } from "@angular/material/list";
import { TranslateModule } from "@ngx-translate/core";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatChipsModule } from "@angular/material/chips";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from "@angular/material/dialog";
import { MatBadgeModule } from "@angular/material/badge";

import { SitesRoutingModule } from "./sites-routing.module";
import { CustomTableModule } from "src/app/shared/modules/custom-table/custom-table.module";
import { TopCardMaterialModule } from "../../shared/modules/top-card-material/top-card-material.module";
import { CategoriesModule } from "src/app/shared/modules/categories/categories.module";
import { PropertiesModule } from "src/app/shared/modules/properties/properties.module";
import { ProtocolFormModule } from "src/app/shared/modules/protocol-form/protocol-form.module";
import { SelectionListModule } from "src/app/shared/modules/selection-list/selection-list.module";
import { SearchFilterModule } from "src/app/shared/modules/search-filter/search-filter.module";
import { WetstockModule } from "../wetstock-Management/wetstock.module";

import { SitesListComponent } from "./sites-list/sites-list.component";
import { SitesDetailsComponent } from "./sites-details/sites-details.component";
import { WarehouseDetailsComponent } from "./warehouses/warehouse-details.component";
import { WarehouseFormDialogComponent } from "./warehouses/dialog/warehouse-form-dialog.component";
import { DispenserDetailsComponent } from "./dispensers/dispenser-details.component";
import { DispenserFormDialogComponent } from "./dispensers/dialog/dispenser-form-dialog.component";
import { FccDetailsComponent } from "./fccs/fccs-details.component";
import { FccFormDialogComponent } from "./fccs/dialog/fcc-form-dialog.component";
import { PosDetailsComponent } from "./pos/pos-detail.component";
import { PosFormDialogComponent } from "./pos/dialog/pos-form-dialog.component";
import { FuelPointDetailsComponent } from "./fuelpoints/fuelpoint-details.component";
import { FuelPointFormDialogComponent } from "./fuelpoints/dialog/fuelpoint-form-dialog.component";
import { StoreProductsComponent } from "./store-products/store-products.component";
import { ProductsComponent } from "./fuel-products/products.component";
import { GradesComponent } from "./grades/grades.component";
import { TankGaugesComponent } from "./tank-gauges/tank-gauges.component";
import { TankGaugeFormDialogComponent } from "./tank-gauges/dialog/tank-gauge-form-dialog.component";
import { PriceSignsComponent } from "./price-signs/price-signs.component";
import { PriceSignFormDialogComponent } from "./price-signs/dialog/price-sign-form-dialog.component";
import { PeripheralDetailsComponent } from "./peripherals/peripheral-details.component";
import { PeripheralFormDialogComponent } from "./peripherals/dialog/peripheral-form-dialog.component";
import { MultimediaDetailsComponent } from "./multimedia/multimedia-details.component";
import { MultimediaFormDialogComponent } from "./multimedia/dialog/multimedia-form-dialog.component";
import { TankGaugeHelperDialogComponent } from "./tank-gauges/dialog/tank-gauge-helper-dialog/tank-gauge-helper-dialog.component";
import { StoreSiteProductsComponent } from "./store-site-products/store-site-products.component";
import { DirectivesModule } from '../../shared/directives/directives.module';
import { StoreFuelProductsComponent } from './store-fuel-products/store-fuel-products.component';
import { FailedProductsDialogComponent } from './store-site-products/dialog/failed-products-dialog/failed-products-dialog.component';
import { ProductPriceSchedulingModule } from '../product-price-scheduling-Management/product-price-scheduling.module';
import { BarCodeGeneratorComponent } from './bar-code-generator/bar-code-generator.component';


@NgModule({
  imports: [
    CommonModule,
    SitesRoutingModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    CustomTableModule,
    TopCardMaterialModule,
    CategoriesModule,
    PropertiesModule,
    MatPaginatorModule,
    MatTableModule,
    MatSortModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatGridListModule,
    MatInputModule,
    MatTabsModule,
    MatSelectModule,
    MatListModule,
    MatCheckboxModule,
    MatCardModule,
    MatProgressBarModule,
    MatAutocompleteModule,
    MatSidenavModule,
    MatChipsModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatBadgeModule,
    ProtocolFormModule,
    SelectionListModule,
    SearchFilterModule,
    WetstockModule,
    DirectivesModule,
    MatTableModule,
    ProductPriceSchedulingModule,
    MatSelectModule
  ],
  declarations: [
    SitesListComponent,
    SitesDetailsComponent,
    WarehouseDetailsComponent,
    WarehouseFormDialogComponent,
    DispenserDetailsComponent,
    DispenserFormDialogComponent,
    FccDetailsComponent,
    FccFormDialogComponent,
    PosDetailsComponent,
    PosFormDialogComponent,
    FuelPointDetailsComponent,
    FuelPointFormDialogComponent,
    ProductsComponent,
    StoreProductsComponent,
    GradesComponent,
    TankGaugesComponent,
    TankGaugeFormDialogComponent,
    TankGaugeHelperDialogComponent,
    PriceSignsComponent,
    PriceSignFormDialogComponent,
    PeripheralDetailsComponent,
    PeripheralFormDialogComponent,
    MultimediaDetailsComponent,
    MultimediaFormDialogComponent,
    StoreSiteProductsComponent,
    StoreFuelProductsComponent,
    FailedProductsDialogComponent,
    BarCodeGeneratorComponent
  ],
})
export class SitesModule {}
